import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxSelectModule } from 'ngx-select-ex';
import { SharedModule } from '../shared/shared.module';
import { InputComponent } from './components/input/input.component';
import { InputRadioComponent } from './components/input-radio/input-radio.component';
import { InputRadioWrapperComponent } from './components/input-radio-wrapper/input-radio-wrapper.component';
import { InputCheckboxComponent } from './components/input-checkbox/input-checkbox.component';
import { InputSwitchComponent } from './components/input-switch/input-switch.component';
import { InputTextComponent } from './components/input-text/input-text.component';
import { InputTextareaComponent } from './components/input-textarea/input-textarea.component';
import { InputSelectComponent } from './components/input-select/input-select.component';
import { InputSelectRegionRegisterComponent } from './components/input-select-region-register/input-select-region-register.component';
import { InputTimeComponent } from './components/input-time/input-time.component';
import { InputMultiSelectComponent } from './components/input-multi-select/input-multi-select.component';
import { InputPasswordComponent } from './components/input-password/input-password.component';
import { InputPasswordConfirmComponent } from './components/input-password-confirm/input-password-confirm.component';
import { InputDateComponent } from './components/input-date/input-date.component';
import { InputFileComponent } from './components/input-file/input-file.component';
import { InputImageComponent } from './components/input-image/input-image.component';
import { OrderCommentDialogComponent } from './dialogs/order-comment-dialog/order-comment-dialog.component';
import { OrderStateDialogComponent } from './dialogs/order-state-dialog/order-state-dialog.component';
// eslint-disable-next-line max-len
import { AdditionalOrderInformationsPreviewDialogComponent } from './dialogs/additional-order-informations-preview-dialog/additional-order-informations-preview-dialog.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { CountrySelectDialogComponent } from './dialogs/country-select-dialog/country-select-dialog.component';
import { InputCheckboxSmallComponent } from './components/input-checkbox-small/input-checkbox-small.component';
import { InputCountriesComponent } from './components/input-countries/input-countries.component';
import { CountrySelectConfirmationDialogComponent } from './dialogs/country-select-confirmation-dialgog/country-select-confirmation-dialog.component';

@NgModule({
	imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, NgxSelectModule, SharedModule, NgbModule, ImageCropperModule],
	providers: [],
	declarations: [
		InputComponent,
		InputSwitchComponent,
		InputPasswordComponent,
		InputPasswordConfirmComponent,
		InputTextComponent,
		InputTextareaComponent,
		InputRadioComponent,
		InputRadioWrapperComponent,
		InputSelectComponent,
		InputTimeComponent,
		InputMultiSelectComponent,
		InputCheckboxComponent,
		InputCheckboxSmallComponent,
		InputDateComponent,
		InputFileComponent,
		InputImageComponent,
		OrderCommentDialogComponent,
		OrderStateDialogComponent,
		AdditionalOrderInformationsPreviewDialogComponent,
		TermsAndConditionsComponent,
		InputSelectRegionRegisterComponent,
		CountrySelectDialogComponent,
		InputCountriesComponent,
		CountrySelectConfirmationDialogComponent
	],
	exports: [
		InputSwitchComponent,
		InputTextComponent,
		InputTextareaComponent,
		InputRadioComponent,
		InputRadioWrapperComponent,
		InputSwitchComponent,
		InputSelectComponent,
		InputTimeComponent,
		InputMultiSelectComponent,
		InputCheckboxComponent,
		InputCheckboxSmallComponent,
		InputPasswordComponent,
		InputPasswordConfirmComponent,
		InputDateComponent,
		NgxSelectModule,
		InputFileComponent,
		InputImageComponent,
		OrderCommentDialogComponent,
		OrderStateDialogComponent,
		AdditionalOrderInformationsPreviewDialogComponent,
		TermsAndConditionsComponent,
		InputSelectRegionRegisterComponent,
		CountrySelectDialogComponent,
		InputCountriesComponent,
		CountrySelectConfirmationDialogComponent
	],
	entryComponents: [
		OrderCommentDialogComponent,
		OrderStateDialogComponent,
		AdditionalOrderInformationsPreviewDialogComponent,
		CountrySelectDialogComponent,
		CountrySelectConfirmationDialogComponent
	]
})
export class FormInputModule {}
